import "styles/Login.css";

import { Card, Flex, Image, Space, theme } from "antd";

import { useAuth } from "hooks/useAuth";
import { CloseCircleOutlined } from "@ant-design/icons";
import useFetch from "hooks/useFetch";
import LoginForm from "components/Login/LoginForm";
import ParticleBackground from "components/Login/ParticleBackground";
import seeAiLogo from "assets/seeai-logo-long.png";

const LoginPage = () => {
  const {
    token: { colorErrorText },
  } = theme.useToken();
  const {
    loading,
    errorMessage,
    doFetch: postLogin,
  } = useFetch("/auth/login", "POST", false);
  const { loginUser } = useAuth();

  const login = (values) => {
    postLogin(values).then((response) => {
      const loginSuccess = !!response?.success && !!response.data?.username;
      if (loginSuccess) {
        loginUser(response.data.username);
      }
    });
  };

  return (
    <>
      <ParticleBackground />
      <div className="login-page">
        <Card className="login-card">
          <Flex vertical={true} gap="middle">
            <Flex justify="center">
              <Image preview={false} height={80} src={seeAiLogo} />
            </Flex>
            <LoginForm loading={loading} onFinish={login} />
            {!!errorMessage && (
              <Space style={{ color: colorErrorText }}>
                <CloseCircleOutlined />
                <div>{errorMessage}</div>
              </Space>
            )}
          </Flex>
        </Card>
      </div>
    </>
  );
};

export default LoginPage;
